import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Actualiza o `document.title` conforme a secção da app.
 *
 * Colocado dentro do `<BrowserRouter>` (para ter acesso a `useLocation`),
 * mapeia o primeiro segmento do pathname → nome da secção. Sempre inclui
 * "I HAVE THE POWER" como sufixo para reforçar marca.
 */
const BRAND = "I HAVE THE POWER";

const SECTION_TITLES = [
  { match: /^\/media(\/|$)/, label: "Media Center" },
  { match: /^\/my(\/|$)/, label: "Portal do Cliente" },
  { match: /^\/admin(\/|$)/, label: "Admin DB" },
  { match: /^\/dreams(\/|$)/, label: "Dreams" },
  { match: /^\/login(\/|$)/, label: "Login" },
  { match: /^\/register(\/|$)/, label: "Registo" },
  { match: /^\/reset-password(\/|$)/, label: "Recuperar Palavra-passe" },
  { match: /^\/areas(\/|$)/, label: "Escolher Área" },
  { match: /^\/cursos\/inscricao(\/|$)/, label: "Inscrição Curso" },
  { match: /^\/cursos\/avaliacao(\/|$)/, label: "Avaliação Curso" },
  { match: /^\/loja(\/|$)/, label: "Loja" },
  { match: /^\/cart\/intent(\/|$)/, label: "Carrinho" },
];

function resolveLabel(pathname) {
  for (const s of SECTION_TITLES) {
    if (s.match.test(pathname)) return s.label;
  }
  // Default: CRM (raiz da app + qualquer rota não mapeada, ex.: /leads,
  // /deals, /orders, /commissions...).
  return "CRM";
}

export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const label = resolveLabel(pathname);
    document.title = label ? `${label} · ${BRAND}` : BRAND;
  }, [pathname]);
  return null;
}
